import { customInterIceptors } from '../../../lib/AxiosProvider';

const API = customInterIceptors();

//community
export const getCommunity = (payload) => {
  return API.get('/community/details', { params: payload });
};
export const leaderboardSettingApi = (payload) => {
  return API.get(`/community/leaderboard`, { params: payload });
};

export const getCommunityMembersList = (payload) => {
  return API.get(`/community/get-members/${payload}`,);
}
export const getCommunityMemberByContactId = (payload) => {
  return API.get(`/community/member-details?contactId=${payload.contactId}&communityId=${payload.communityId}`,);
}
//community owner
export const getCommunityOwner = (payload) => {
  return API.get('/community/owner', { params: payload });
};

//community members
export const getCommunityMembers = (payload) => {
  return API.get('/community-members', { params: payload });
};

export const getCommunityFavoriteMembers = (payload) => {
  return API.get('/community-favorite-members', { params: payload });
};

export const getCommunityGroups = (payload) => {
  return API.get('/community-group/community/group', { params: payload });
};

export const getCommunityGroupsByUser = (payload) => {
  return API.get('/community-group/community/group/user', { params: payload });
};

export const getCommunityInvitedByContact = (payload) => {
  return API.get('/community-members/invited-bycontact', { params: payload });
};
export const getCommunityMemberDetailsById = (id) => {
  return API.get(`/community-members/details/${id}`);
};
export const updateCommunityMemberProfile = (payload) => {
  return API.patch(`/community-members/profile/update/`, payload);
};

export const editGoals = (payload, id) => {
  return API.put('/user-goal/update_goal_subgoal/' + id, payload);
};
//Community group
export const getGroupsByCommunity = (payload) => {
  return API.get(`/community-group/community/group/`, { params: payload }); // id is community id
};
export const getGroupsByCommunityApproved = (payload) => {
  return API.get(`/community-group/community/group/approved`, { params: payload }); // id is community id
};
export const getGroupByContactId = (payload) => {
  return API.get(`/community-group/community/group/contact`, { params: payload }); // id is community id
};
export const getGroupDetails = (id, contactId) => {
  return API.get(`/community-group/community/${id}?contactId=${contactId}`);
};
export const markMessageRead = (payload) => {
  return API.put(`/community-group-livechat/read-message?groupId=${payload.groupId}&contactId=${payload.contactId}`,);
}
//community Posts
export const getCommunityPosts = (payload) => {
  return API.get(`/community-post/community`, { params: payload });
};
export const getRecentNews = (payload) => {
  return API.get(`/community-post/recent-news`, { params: payload });
};
export const getGroupPosts = (payload) => {
  return API.get(`/community-post/`, { params: payload });
};
export const getContactPosts = (payload) => {
  return API.get(`/community-post/contact`, { params: payload });
};
export const getUserPosts = (payload) => {
  return API.get(`/community-post/user`, { params: payload });
};
export const addPost = (payload) => {
  return API.post(`/community-post/`, payload);
};
export const editPost = (id, payload) => {
  return API.put(`/community-post/${id}`, payload);
};
export const deletePost = (id) => {
  return API.delete(`/community-post/${id}`);
};
export function likeCommunityPost(payload) {
  return API.post(`/community-post/like`, payload);
}
export function dislikeCommunityPost(payload) {
  return API.post(`/community-post/dislike`, payload);
}
export function createPostReport(payload) {
  return API.post('/post-report/', payload);
}
export function getContactCommunityPosts(payload) {
  return API.get(`/community-post/community`, { params: payload });
}

//Pin Post
export function pinCommunityPost(payload) {
  return API.post('/community-post/pin/', payload);
}
export function unpinCommunityPost(payload) {
  return API.post('/community-post/unpin/', payload);
}
export function getPinnedCommunityPosts(payload) {
  return API.get('/community-post/pinned-posts/', { params: payload });
}

//group members
export const requestToJoinGroup = (payload) => {
  return API.post(`/community-group/members/`, payload); // status:requested
};
export const getGroupMembers = (payload) => {
  return API.get(`/community-group/members/approved`, { params: payload });
};

//Following & followers
export const getFollowers = (payload) => {
  return API.get(`/community-follow/followers/`, { params: payload });
};
export const getFollowings = (payload) => {
  return API.get(`/community-follow/following/`, { params: payload });
};
export const followContact = (payload) => {
  return API.post(`/community-follow/`, payload);
};
export const unfollowContact = (followId, followingId) => {
  // return API.delete(`/community-follow/${id}`);
  return API.delete(`/community-follow`, { data: { followId, followingId } });
};
export const inviteMember = (payload) => {
  return API.post('/community-members/invite', payload);
};
export const removeInvitedMember = (id) => {
  return API.delete(`/community-members/invited/${id}`);
};
//Profile Community
export function getProfileRanks(contactId) {
  return API.get(`/community-profile/ranks/${contactId}`);
}
export function getContactCurrentRank(contactId) {
  return API.get(`/community-profile/ranks-current/${contactId}`);
}
export function getProfileAchievements(contactId) {
  return API.get(`/community-profile/achievements/ranks/${contactId}`);
}

// course
export function getProfileCourses(contactId) {
  return API.get(`/community-profile/courses/${contactId}`);
}

export function getProfileCoursesHomepage({ contactId, payload }) {
  return API.get(`/community-profile/purchases/courses/${contactId}`, { params: payload });
}

export const getProfileCourseByCourseId = (courseId) => {
  return API.get(`/course/courseId/${courseId}`);
};

export const getLessonsByCourseId = (payload) => {
  return API.get(`/community-profile/lessons/${payload?.courseId}/${payload?.contactId}`);
};

// course assets
export const getCourseAssets = (courseId) => {
  return API.get(`/course/assets/${courseId}`);
};
export const getCourseCertificate = (courseId, studentId) => {
  return API.get(`/course/get-course-certificate/${courseId}`, { params: { studentId } });
};

// course quiz
export const getAllQuizResults = (invoiceId, courseId, resultType) => {
  return API.get(`/course/submitedQuizAnswers/${invoiceId}/${courseId}/${resultType}`);
};

export const getQuizAnswers = (invoiceId, quizId) => {
  return API.get(`/course/getQuizResultAnswers/${invoiceId}/${quizId}`);
};

export const getRecordWatchTime = (invoiceId) => {
  return API.get(`/course/get-recorded-video-watch-time/?invoiceId=${invoiceId}`);
};

export const recordWatchTime = (invoiceId, videoId, currentWatchedTime) => {
  return API.put(`/course/record-video-watch-time/?invoiceId=${invoiceId}&videoId=${videoId}`, {
    currentWatchedTime
  });
};

export const getCourseVideoPlayerActivity = (courseId, invoiceId,contactId) => {
  return API.get(`/course/get-video-player-activity/${courseId}/${invoiceId}/${contactId}`);
};

export const updateCourseVideoPlayerActivity = (courseId, invoiceId, courseVideoSettings) => {
  return API.put(
    `/course/update-video-player-activity/${courseId}/${invoiceId}`,
    courseVideoSettings
  );
};

export const getCourseCompleteProgressReport = (courseId, invoiceId) => {
  return API.get(`/course/get-course-progress-report?courseId=${courseId}&invoiceId=${invoiceId}`);
};

export const getAuthorTotalCourseCount = (userId) => {
  return API.get(`/course/get-course-count?userId=${userId}`);
};

export const getCardProgressReportAPI = (data) => {
  return API.get(`/course/get-course-card-progress-report/?courseId=${data?.courseId}&contactId=${data?.contactId}`);
};

export const getCurrentCourseStudentCount = (courseId) => {
  return API.get(`/course/get-course-student-count?courseId=${courseId}`);
};

export function getProfileContracts(contactId) {
  return API.get(`/community-profile/contracts/${contactId}`);
}
export function getProfileTasks(contactId) {
  return API.get(`/community-profile/tasks/${contactId}`);
}
export function sharedGoalApi(payload) {
  return API.get(`/user-goal/shared_goal`, { params: payload });
}
export function getProfileEvents(contactId) {
  return API.get(`/community-profile/events/${contactId}`);
}
export const getGoal = (id) => {
  return API.get('/user-goal/' + id);
};
export const fetchSubGoals = (id) => {
  return API.get('/user-goal/goals_By_parengoalId/' + id);
};
export async function getProfileOrders(contactId, payload) {
  return API.get(`/community-profile/orders/${contactId}`, { params: payload });
}
export async function getProfileFiles(contactId) {
  return API.get(`/community-profile/files/${contactId}`);
}
export async function getProfile(contactId) {
  return API.get(`/community-profile/profile/${contactId}`);
}

export async function updateProfile(contactId, payload) {
  return API.put(`/community-profile/profile/${contactId}`, payload);
}
export async function getFamilyMembers(payload) {
  return API.get(`/community-profile/family/${payload.contactId}`, { params: payload });
}
export async function addFamilyMember(payload) {
  return API.post(`/community-profile/family/`, payload);
}

//Profile Payment methods
export const getContactStripeCards = (customerId) => {
  //id is customerId of stripe
  return API.get(`payment/stripe/cards/${customerId}`);
};
export const insertContactStripeCards = (customerId, payload) => {
  //id is customerId of stripe
  return API.post(`payment/stripe/cards/${customerId}`, payload);
};
export const updateContactStripeCards = (paymentMethodId, payload) => {
  //id is customerId of stripe
  return API.put(`payment/stripe/cards/${paymentMethodId}`, payload);
};
export const getStripeCustomer = (payload) => {
  //name, email, stripeAccountId, isUser, contactId, addToContact, organizationId
  return API.post('/payment/stripe/customer', payload);
};
export const getStripeCustomerById = (payload) => {
  return API.get(`/payment/stripe/customer-details-public`, { params: payload });
};
export const detatchContactStripeCard = (paymentMethodId) => {
  return API.delete(`/payment/card/${paymentMethodId}`);
};
export const updateStripeDefaultPaymentMethod = (payload) => {
  return API.put('/payment/stripe/default-payment', payload);
};
export const updateCardPayment = (id, payload, isPublic) => {
  return isPublic === true
    ? API.put(`/invoice/update-public-card-payment/${id}`, payload)
    : API.put(`/invoice/update-card-payment/${id}`, payload);
};
export const createNMITransaction = (payload) => {
  return API.post('/payment/nmi/transaction', payload);
};
export const getShopByPath = (path) => {
  return API.get(`/shop/get/${path}`);
};
export const createIntent = (payload) => {
  return API.post('/payment/stripe/payment-intent', payload);
};
export const getDefaultPayment = (payload) => {
  return API.post('/payment/default', payload);
};
export const getStripeConfig = (payload) => {
  return API.get('/payment/stripe/config', { params: payload });
};

export const getNMICards = async (payload) => {
  return API.post('/payment/nmi/customer/cards', payload);
};
export const addNMICard = async (payload) => {
  return API.post('/payment/nmi/customer/cards/add', payload);
};

//notifications
export async function getNotifications(payload) {
  return API.put(`/community-notifications/`, { params: payload });
}

// ADMIN DETAILS
export const getuserById = (id) => {
  ///get-super/:id
  return API.get(`/user/${id}`);
};

export const getShopByUser = (payload) => {
  return API.get('/shop/get/user',{params:payload});
};

//live chat

// export const getLiveChatHistory = (payload) => {
//   return API.get('/community-livechat', { params: payload });
// }

// export const addStarMember = (id, payload) => {
//   return API.put(`/community-favorite-members/add-star/${id}`, payload)
// }

// export const removeStarMember = (id, payload) => {
//   return API.put(`/community-favorite-members/remove-star/${id}`, payload)
// }
export const sendGroupChatMessage = (payload) => {
  return API.post(`/community-group-livechat/`, payload);
};
export const getGroupLiveChatHistory = (payload) => {
  return API.get('/community-group-livechat', { params: payload });
};

export const getCommunityChatList = (contactId) => {
  return API.get(`/community-livechat/dms/${contactId}`);
};
export const getCommunityOwnerChats = (contactId) => {
  return API.get(`/community-livechat/dms-owner-list/${contactId}`);
};
export const getCommunityContactChats = (payload) => {
  return API.get(`/community-livechat/dms-list/`, { params: payload });
};
export const sendChatMessage = (payload) => {
  return API.post(`/community-livechat/`, payload);
};

export const sendClientDm = (payload) => {
  return API.post(`/community-livechat/dm-client`, payload);
};

export const getChatMessages = (payload) => {
  return API.get(`/community-livechat/get-chat-messages`, { params: payload });
}

export const seenChatMessage = ({communityId, sender, receiver}) => {
  return API.put(`/community-livechat/seen-message?communityId=${communityId}&sender=${sender}&receiver=${receiver}`);
};

export const getTournaments = (payload) => {
  return API.get('/community-events/tournaments', { params: payload });
};

export const getUpcomingEvents = (payload) => {
  return API.get('/community-events/upcoming', { params: payload });
};

export const submitQuizResult = (payload) => {
  return API.post('/course/submitQuizAnswer', payload);
};

// Badge
export const updateCommunity = (payload, Id) => {
  return API.put(`/community/${Id}`, payload);
};
export const createCommunityBadge = (payload) => {
  return API.post('/community-badges', payload);
};
export const getCommunityBadges = (Id) => {
  return API.get(`/community-badges/${Id}`);
};
export const updateCommunityBadge = (payload, Id) => {
  return API.put(`/community-badges/${Id}`, payload);
};

export const deleteCommunityBadge = (Id) => {
  return API.delete(`/community-badges/${Id}`);
};

//Points and Rewards


//Reward Setting

export const getTopMemberApi = (payload) => {
  return API.get(`/community/top-member`, { params: payload });
};

export const getTopAmbasdorApi = (payload) => {
  return API.get(`/community/top-ambassador`, { params: payload });
};

//Events
export const getEvents = (payload) => {
  return API.get('/community-events/events', { params: payload });
};
export const getEventById = (id) => {
  return API.get(`/event/info/${id}`);
};
export const getEventTournamentDiviisons = (payload) => {
  return API.post(`/tournament/division/multi/`,payload);
};
export const getEventTournamentEvents = (payload) => {
  return API.post(`/tournament/event/multi/`,payload);
};
export const createIncome = (payload) => {
  return API.post(`/income/public`, payload);
};
export const updateIncome = (id,payload) => {
  return API.put(`/income/${id}`, payload);
};
export const payStripeSavedCards = (payload) => {
  //amount, customerId, currency, paymentMethod, accountId, passOnCC
  return API.post(`membership-buy/stripe/pay-saved-card`, payload);
};
export const tournamentCreateBracket = (id,payload) => {
  return API.post(`tournament/mock-bracket/${id}`, payload);
};

//events 
export const registerEvent = (payload) => {
  return API.post(`/event/register`, payload);
};
export const isRegisteredInEvent = (payload) => {
  return API.post(`/event/is-register`, payload);
};
export const updateGuestInEvent = (id,payload) => {
  return API.put(`/event/update-registered/${id}`, payload);
};
export const getEventMemberships = (payload) =>{
  return API.post(`/event/event-memberships`,payload)
}
export const getContactEventMembershipsActive = (payload) =>{
  return API.post(`/event/event-contact-active-membership`,payload)
}

//rank category
export const getProgressionCategories = (payload) => {
  return API.post(`/community-profile/progression-categories`, payload);
};
export const getProgressionRanks = (payload) => {
  return API.post(`/community-profile/ranks`, payload);
};
export const insertContactRank = (payload) => {
  return API.post(`/community-profile/ranks-contact`, payload);
};

export const getMyTaskWorkspaceApi = () => {
  return API.get('/project-manager-kanban/get-shared-workspaces');
};

export const getMyTaskBoardsApi = (workSpaceId) => {
  return API.get(`/project-board/get-shared-boards?workSpaceId=${workSpaceId}`);
};

export const getMyTaskColumnsApi = (payload) => {
  return API.get('/project-column/get-all-column', { params: payload });
};

export const updateMyTaskStatusApi = (id, payload) => {
  return API.patch(`/project-cards/update-card/${id}`, payload);
};

export const getSelfTaskApi = (payload) => {
  return API.get(`/project-cards/get-task-assignedmember/${payload?.contactId}`,{params:payload?.payload});
};

export const createCommentApi = (payload) => {
  return API.post(
    `/project-comments/create-comment?boardId=${payload.boardId}&cardId=${payload.cardId}&workSpaceId=${payload.workSpaceId}`,
    payload
  );
};

export const getCommentApi = (payload) => {
  return API.get(`/project-comments/get-all-comment`, { params: payload });
};

export const getCardActivitiesApi = (payload) => {
  return API.post(`/project-activity/get-card-activities`, payload);
};

export const updateCardTodosApi = (payload) => {
  return API.put(`/project-card-todo/update`, payload);
};

export const getCardDetailsApi = (uuId) => {
  return API.get(`/project-cards/get-card/${uuId}`);
};

export const getMyProjectColumnsApi = (payload) => {
  return API.get('/project-column/get-all-column', { params: payload });
};

export const updateMyProjectCardApi = (id, payload) => {
  return API.patch(`/project-cards/update-card/${id}`, payload);
};

export const menuLabelsGetApi = ({ boardId, searchTerm }) => {
  return API.get(`/project-labels/get-all-labels?boardId=${boardId}&searchTerm=${searchTerm}`);
};

export const getBoardListOfWorkspaceApi = (workspaceId) => {
  return API.get(`/project-board/get-board?workSpaceId=${workspaceId}`);
};
